import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPostDateUrl,
  getPutDateForSingleQuoteUrl
} from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";
import { partPaymentGoCardlessWarningOf, showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";

const initialState = {};

const datePickerSlice = createSlice({
  name: "datepicker",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postDateThunk.rejected, (state, action) => {
        showToast(action.payload?.data?.message, showToastType.error);
      })
      .addCase(putDateThunk.rejected, (state, action) => {
        // The GoCardless notice shows this one, so no error toast.
        if (partPaymentGoCardlessWarningOf(action.payload)) {
          return;
        }
        showToast(action.payload?.data?.message, showToastType.error);
      });
  }
});

// Async thunk to get Comments data
export const postDateThunk = createAsyncThunk(
  "datepicker/postDateThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(getPostDateUrl, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Async thunk to get Comments data
export const putDateThunk = createAsyncThunk(
  "datepicker/putDateThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.put(
        getPutDateForSingleQuoteUrl,
        payload,
        { params: { checkEligibility: true } }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export default datePickerSlice.reducer;
